(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ny-typography"] && !Shopify.designMode) return;
  try {
    const applyStockTypography = (root) => {
    if (!(root instanceof Element)) return;
    const messages = new Set(root.querySelectorAll('.hengam-low-stock-description'));
    const parent = root.closest('.hengam-low-stock-description');
    if (parent) messages.add(parent);
    for (const message of messages) {
      for (const paragraph of message.querySelectorAll('p')) {
        paragraph.style.setProperty('color', 'var(--ny-ink)', 'important');
      }
    }
  };
  const initializeStockTypography = () => {
    if (!document.body.classList.contains('product')) return;
    applyStockTypography(document.body);
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) applyStockTypography(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStockTypography, { once: true });
  } else {
    initializeStockTypography();
  }
  } catch(e) { console.error(e); }
})();

})();
